import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Products from "@/components/Products";
import TradeForm from "@/components/TradeForm";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => (
  <div data-testid="home-page" className="min-h-screen bg-white">
    <Navbar />
    <Hero />
    <Marquee />
    <About />
    <Products />
    <TradeForm />
    <Faq />
    <Contact />
    <Footer />
  </div>
);

export default function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#FFFFFF",
            border: "4px solid #FF1F1F",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "0.85rem",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            fontWeight: 700,
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
